module.exports = __webpack_public_path__ + "static/media/pawPassIcon.83f55c18.png";